import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['./table-header.component.css']
})
export class TableHeaderComponent {
    @Input() title: string = 'Patient lists';
    @Input() showAddButton: boolean = true;
    @Input() buttonText: string = 'Add New Patient';
    @Output() onAddClick = new EventEmitter<void>();

    handleAddClick() {
        this.onAddClick.emit();
    }
}
